module.exports = __webpack_public_path__ + "img/2m.ed16d112.png";